import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {SubSink} from '@Common/core/utils/subsink';
import {Individu, IndividuService, PubSubService} from '@Common/core/services';
import {Loaning} from '../../common/services/loaning/loaning.model';
import {ActivatedRoute, Router} from '@angular/router';
import {HelperIndividuService} from '../../common/services/helper-individu/helper-individu.service';
import {MatDialog} from '@angular/material/dialog';
import {LoaningService} from '../../common/services/loaning/loaning.service';
import {finalize} from 'rxjs/operators';
import {LoaningState} from '../../common/services/loaning/loaning-states.enum';
import {RouterExtService} from '@Services/base/router/router.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-loaning-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConsultationComponent implements OnInit {
  @Input() loaning: Loaning;
  @Input() displayTitle = true;
  @Input() returnList = true;
  individu: Individu;
  isGestionnaire: boolean;
  loaningState = LoaningState;
  selectedTabIndex = 0;
  loading = false;
  emails = [];
  private _previousUrl;
  private subSink = new SubSink();
  constructor(private router: Router,
              private route: ActivatedRoute,
              public dialog: MatDialog,
              private routerExtSvc: RouterExtService,
              private pubSubSvc: PubSubService,
              private individuService: IndividuService,
              private helperIndividuService: HelperIndividuService,
              public loaningSvc: LoaningService) { }

  ngOnInit(): void {
    this._setConnected();
    this._getIdLoaningByUrl();
    this._previousUrl = this.routerExtSvc.getPreviousUrl();
  }
  canManage() {
    return this.isGestionnaire;

  }
  private _userInfo(long: boolean) {
    if (this.loaning?.last_name && this.loaning?.first_name) {
      if (long) {
        return `Demande créée par ${this.loaning?.borrower_obj.last_name} ${this.loaning?.borrower_obj.first_name} pour ${this.loaning?.last_name} ${this.loaning?.first_name}`;
      } else {
        return `${this.loaning?.last_name} ${this.loaning?.first_name}`;
      }
    }
    return `${this.loaning?.borrower_obj.last_name} ${this.loaning?.borrower_obj.first_name}`;
  }
  userInfo() {
    return this._userInfo(false);
  }
  userInfoLong() {
    return this._userInfo(true);
  }
  goBack() {
    if (this._previousUrl) {
      this.router.navigate([this._previousUrl]);
    }
  }
  private _setConnected() {
    this.subSink.sink = this.individuService.individu$.subscribe(individu => {
      this.isGestionnaire = this.helperIndividuService.isGestionnaire;
      this.individu = individu;
    });
  }
  private _getIdLoaningByUrl() {
    const _loaningUuid = this.route.snapshot.params['id'];
    if (_loaningUuid) {
      this._getLoaning(_loaningUuid);
    }
  }
  private _getLoaning(loaningUuid: string): void {
    this.loading = true;
    this.pubSubSvc.publish('loading', this.loading);
    this.subSink.sink = this.loaningSvc
      .get(loaningUuid)
      .pipe(finalize(() => {
        this.loading = false;
        this.pubSubSvc.publish('loading', this.loading);
      }))
      .subscribe((_loaning: Loaning) => {
        this.loaning = _loaning;
        this.emails.unshift([this.individu.email_pro, this.loaning.borrower_obj.email_pro]);
      });
  }

  exportZipScansConsultation() {
    const { scans_obj } = this.loaning;
    if (scans_obj.length > 1) {
      this.exportMultipleScansConsultation(this.loaning);
    } else if (scans_obj.length === 1) {
      this.downloadSingleScan();
    }
  }

  exportMultipleScansConsultation(loaning: Loaning) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc
      .exportZipScansConsultation(loaning)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe((data: Blob) => {
        const zipName = `${loaning.reference}`;
        const fileName = `${zipName}.zip`;
        saveAs(data, fileName);
      });
  }

  downloadSingleScan() {
    // Cas ou il'y as un seul scan
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.loaningSvc
      .downloadSingleScan(this.loaning.scans_obj[0])
      .pipe(
        finalize(() => this.pubSubSvc.publish('loading', false)),
      )
      .subscribe();
  }

  showExportZipBtn() {
    return (this.loaning.status === LoaningState.DONE && this.loaning.scans_obj.length > 0);
  }


}
